import { getEnv } from '../environment';
import request from './request';

export const getStatesByCountryId = async (countryId: string) => {
  return await request({
    path: `${getEnv().REACT_APP_LOCALIZATION_URL}/states/by-country-id/${countryId}`,
  });
};
